import { render, staticRenderFns } from "./TankSvg.vue?vue&type=template&id=3992e74b&"
import script from "./TankSvg.vue?vue&type=script&lang=js&"
export * from "./TankSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports